module.exports = __webpack_public_path__ + "static/media/il.9d9ea844.svg";